import React from "react";
import { IconHomeCheck, IconHomeSearch } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ButtonPrime from "@/components/navigation/ButtonPrime";

export default function CallToAction() {
  const navigate = useNavigate();
  return (
    <div className="  max-w-7xl mx-2 xl:mx-auto overflow-hidden  rounded-lg">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-6 items-center">
        {/* Left Side Image */}
        <div className="max-h-[33rem]">
          <img
            className="object-cover rounded-r-none w-full h-60 md:h-full max-h-[35rem] rounded-md"
            src="/Fotos/landingpage-bewertung-jakobs.jpg"
            alt="Ein Bild von einer Landschaft mit Preisschildern über den Häusern"
          />
        </div>

        {/* Right Side CTA Content */}
        <div className="space-y-4 flex flex-col h-full justify-around px-2 pb-5">
          <div className="translate-y-">
            <div className="flex flex-col gap-10">
              <h2 className="text-2xl lg:text-4xl font-bold text-center md:text-left text-gray-800">
                Erbschaft, Trennung oder ein neuer Lebensabschnitt?
              </h2>
              <p className="text-lg text-center md:text-left text-gray-600 pt-2">
                Wenn sich das Leben ändert, braucht es Klarheit. Lassen Sie Ihre
                Immobilie kostenlos bewerten – als sichere Basis für die
                nächsten Schritte.
              </p>
            </div>
          </div>
          <div className="">
            <ButtonPrime
              className="flex w-full md:w-fit items-center mt-5 md:mt-0"
              onClick={() => {
                navigate("/bewerten/formular/online-bewertung");
                umami.track(`call_to_action_bewerten`, "click");
              }}
            >
              <IconHomeCheck className="max-w-10 max-h-10 inline mr-3" />
              Immobilienwert erfahren
            </ButtonPrime>
          </div>
        </div>
      </div>
    </div>
  );
}
